import { atom } from 'jotai';

const filterTrayOpenAtom = atom(false);

export { filterTrayOpenAtom };
